import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

export default function TableItem({
  email,
  handleFeedback,
  handleShow,
  handleDelete,
}) {
  function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }

  const copied = () => {
    toast.success("Text Copied", {
      position: "bottom-center",
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });
  };

  return (
    <tr key={email.id}>
      {/* <th scope="row">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            // name="chk_child"
            defaultValue={apple.id}
            onChange={handleCheckboxChange}
            // checked={checkedItems.includes(apple.id)}
          />
        </div>
      </th> */}
      <td className="id" style={{ display: "none" }}>
        {/* <Link to="#" className="fw-medium link-primary"> */}
        {email.id}
        {/* </Link> */}
      </td>
      <td className="customer_name">{email.id}</td>
      <td className="email">{email.name}</td>
      <td className="email">{email.city}</td>
      <td className="email">{email.product}</td>
      <td className="date">{timeSince(new Date(email.created_at))}</td>
      <td className="status">
        <span
          className={`badge  text-uppercase ${
            email.feedback == null || email.feedback == ""
              ? "badge-soft-danger"
              : "badge-soft-success"
          }`}
          style={{ fontSize: 14 }}
        >
          {email.feedback == null || email.feedback == ""
            ? "No Feedback"
            : "Checked"}
        </span>
      </td>
      <td>
        <div className="d-flex gap-2">
          <div className="copy">
            <button
              className="btn btn-md edit-item-btn"
              style={{ background: "#16b16a", color: "white" }}
              onClick={() => handleFeedback(email.id)}
            >
              <i class="ri-add-line  align-bottom"></i>
            </button>
          </div>

          <div className="copy">
            <button
              className="btn  btn-success btn-md edit-item-btn"
              onClick={() => handleShow(email.id)}
            >
              <i class="ri-mail-open-line  align-bottom"></i>
            </button>
          </div>
          <div className="remove">
            <button
              className="btn  btn-danger btn-md remove-item-btn"
              onClick={() => handleDelete(email.id)}
            >
              <i class="ri-delete-bin-6-line  align-bottom"></i>
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
}
